export default __webpack_public_path__ + "static/media/welcome-tour-1-mob.7ba2e15b.png";